// Approvals
export const tableColumns = {
  RequestId: 'ID',
  ApprovalTyp: 'Request Type',
  RequestDate: 'Date',
  Requester: 'Requester',
  RequestDetails: 'Details',
  'Primary Approver': 'Primary Approver',
  'Secondary Approver': 'Secondary Approver',
};
